// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconNotificationInfo: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                fill="#53ACDB"
                d="M8,16 C12.40625,16 16,12.40625 16,8 C16,3.59375 12.40625,0 8,0 C3.59375,0 0,3.59375 0,8 C0,12.40625 3.59375,16 8,16 Z M7,5 C7,4.4375 7.4375,4 8,4 C8.5625,4 9,4.4375 9,5 C9,5.5625 8.5625,6 8,6 C7.4375,6 7,5.5625 7,5 Z M6.75,7 L8.25,7 C8.65625,7 9,7.34375 9,7.75 L9,10.5 L9.25,10.5 C9.65625,10.5 10,10.84375 10,11.25 C10,11.65625 9.65625,12 9.25,12 L6.75,12 C6.34375,12 6,11.65625 6,11.25 C6,10.84375 6.34375,10.5 6.75,10.5 L7.5,10.5 L7.5,8.5 L6.75,8.5 C6.34375,8.5 6,8.15625 6,7.75 C6,7.34375 6.34375,7 6.75,7 Z"
            />
        </svg>
    );
};

export default React.memo(IconNotificationInfo);
